import React, { FC } from 'react'
import { SettingsPageContainer } from './SettingsPage.styles'

export const SettingsPage: FC = () => {
  const onMyFrameLoad = () => {
    console.log('iframe loaded')
  }

  return (
    <SettingsPageContainer>
      <iframe
        id="iframe"
        src="https://demo-sample-shop-fe28f2eb61a8.herokuapp.com/"
        onLoad={onMyFrameLoad}
      />
      <iframe
        id="iframe"
        src="https://onboarding-proxy-web.vercel.app/"
        onLoad={onMyFrameLoad}
      />
      <iframe
        id="iframe"
        src="https://payment-authorization.prod.identity.signicat.global/"
        onLoad={onMyFrameLoad}
      />
    </SettingsPageContainer>
  )
}
